import React from "react";
import SocialMediaIcons from "./SocialMedia";

const SalesPageHeader = () => (
    <section className="head top-header-sales-page py-3">
        <div className="container px-5">
            <div className="d-flex align-items-center w-100 flex-wrap">
                {/* Logo - left aligned */}
                <div className="flex-shrink-0 d-flex align-items-center justify-content-start" style={{ width: "22%", minWidth: 140 }}>
                    <img
                        className="img-fluid"
                        src="../../assets/images/logo.svg"
                        alt="Logo user"
                        style={{ height: "100px" }}
                    />
                </div>
                {/* Welcome Text - center aligned */}
                <div className="flex-grow-1 d-flex align-items-center justify-content-center" style={{ minWidth: 0 }}>
                    <h5 className="fs-5 fs-md-3 fw-bold text-success mb-0 text-center w-100" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        Welcome to FRAYO Subscription
                    </h5>
                </div>
                {/* Social Media Icons - right aligned */}
                <div className="flex-shrink-0 d-flex align-items-center justify-content-end" style={{ width: "22%", minWidth: 140 }}>
                    <SocialMediaIcons />
                </div>
            </div>
        </div>
    </section>
);

export default SalesPageHeader;
